"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhiteLabelFeature = void 0;
exports.WhiteLabelFeature = {
    SignUp: 'SignUp',
    Login: 'Login',
    PhoneLogin: 'PhoneLogin',
    AppleLogin: 'AppleLogin',
    GoogleLogin: 'GoogleLogin',
    FacebookLogin: 'FacebookLogin',
    LineLogin: 'LineLogin',
    BackgroundImage: 'BackgroundImage',
    WeChatLogin: 'WeChatLogin',
    KakaoLogin: 'KakaoLogin',
    OtpLogin: 'OtpLogin',
    WhatsAppLogin: 'WhatsAppLogin',
    UserSessionManagement: 'UserSessionManagement',
    PasskeyAuthentication: 'PasskeyAuthentication',
};
//# sourceMappingURL=whiteLabelFeature.js.map